<template>
  <div class="displayPage">
    <div class="btn">缓存清除完毕！</div>
        <!-- <div class="btn" @click="clearFn">清除缓存</div>
        <div class="btn" @click="toHome">返回首页</div> -->
        <!-- <div class="icon iconfont icon-icon-test"></div> -->
  </div>
</template>
<script>
import Vue from 'vue'
import config from '@/config/index'

export default {
  data () {
    return {

    }
  },
  created(){
    this.clearFn()
  },
  methods : {
    clearFn(){
      localStorage.setItem('token_key','')
      localStorage.setItem('appId','')
      window.location.href = config.baseUrl;
    },
    toHome(){
      this.$router.push({
        path: '/',
        query: {}
      })
    }
  }
  
}
</script>

<style scoped lang="less">
  .displayPage{
     min-height: 100%;
     box-sizing: border-box;
     padding-top: 100px;
    

    .btn{
      width: 200px;
      height: 50px;
      text-align: center;
      margin: 0 auto;
    }

    .icon{
       font-size: 50px;
       width: 50px;
       height: 50px;
       display: flex;
      align-items: center;justify-content: center;
    }

  }
</style>
